import React from "react";
import { createUseStyles } from "react-jss";

const useStyles = createUseStyles(theme => ({
  pageInner: {
    maxWidth: '110rem',
    margin: '0 auto',
    padding: '0 1.2rem',
    [`@media(min-width: ${theme.breakpoints.medium.min})`]: {
      padding: '0 5rem'
    }
  },
  pageOuter: {
    maxWidth: "1280px",
    // maxWidth: '125rem',
    margin: '0 auto'
  }
}));

export const PageInner = ({ children, className, ...rest }) => {
  const styles = useStyles();
  return <div className={`${styles.pageInner} ${className}`} {...rest}>{children}</div>
};

PageInner.defaultProps = {
  className: ''
};

export const PageOuter = ({ children, className, ...rest }) => {
  const styles = useStyles();
  return <div className={`${styles.pageOuter} ${className}`} {...rest}>{children}</div>
};

PageOuter.defaultProps = {
  className: ''
};

